import CaptureShell from '../../../layouts/CaptureShell.vue';
import SkillsGapAnalysis from '../views/SkillsGapAnalysis.vue';
import SkillsGapAnalysisQR from '../views/sections/QR.vue';
import ViewPrivacyPolicy from '../views/sections/ViewPrivacyPolicy.vue';
import ImageCropperModal from '../views/sections/ImageCropperModal.vue';
import workflow from './workflow';

export default [{
  path: '/',
  name: 'sgaQuestionaireModule',
  component: CaptureShell,
  children: [{
    path: '/sga/questionnaire',
    name: 'sga',
    component: SkillsGapAnalysis,
    title: 'SkillsSensus',
    children: workflow
    },
    {
      path: 'crop-image/:imgToCrop',
      name: 'ImageCropperModal',
      component: ImageCropperModal,
      title: 'Image Cropper',
    },
    {
      path: '/sga/questionnaire',
      name: 'ViewPrivacyPolicy',
      component: ViewPrivacyPolicy,
      title: 'View Privacy Policy',
    },
    {
      path: '/sga/questionnaire/thankyou',
      name: 'sgaQR',
      component: SkillsGapAnalysisQR,
        meta: {
          type: 'small'
        }
    },
  ]
}];
